import * as React from 'react';

import { IPinsLayer } from './usePinsLayer';
import { useOfferHoverApi } from '../../../../common/containers/OfferHoverProvider';
import { TFeature } from '../../../../common/types/map';

type TUsePinHoverParams = Pick<IPinsLayer, 'balloonManager'>;

// Подсветка пина при наведении курсора на сам пин: кормит общий механизм (useOfferHoverPin) через провайдер,
// не заводя второго владельца isHovered. YMaps шлёт синтетические mouseenter/mouseleave через events-pane.
export function usePinHover({ balloonManager }: TUsePinHoverParams): void {
  const { setHoveredOfferId, resetHoveredOfferId } = useOfferHoverApi();

  React.useEffect(() => {
    const { objects } = balloonManager.objectManager;

    const handlePinEnter = (event: YMaps.IEvent) => {
      const objectId = event.get<string | undefined>('objectId');
      if (!objectId) {
        return;
      }

      const realtyId = objects.getById<TFeature>(objectId)?.properties.offers[0]?.realtyId;
      if (realtyId === undefined) {
        return;
      }

      setHoveredOfferId(realtyId, 'pin');
    };

    const handlePinLeave = () => {
      resetHoveredOfferId();
    };

    objects.events.add('mouseenter', handlePinEnter);
    objects.events.add('mouseleave', handlePinLeave);

    return () => {
      objects.events.remove('mouseenter', handlePinEnter);
      objects.events.remove('mouseleave', handlePinLeave);
    };
  }, [balloonManager, setHoveredOfferId, resetHoveredOfferId]);
}
